import React from 'react';
import styled from 'styled-components';

import Wrapper from '../../elements/wrapper';
import { media } from '../../helpers';

const PostContentContainer = styled.div`
    .post-content-wrapper {
        ${media.medium`max-width: 60vw;`}

        .gatsby-image-wrapper {
            width: 100% !important;
        }
    }
`;

const PostContent = ({ content }) => {
    function generateContent() {
        return { __html: content };
    }
    return (
        <PostContentContainer>
            <Wrapper className="post-content-wrapper">
                <div
                    className="inner-wrap"
                    dangerouslySetInnerHTML={generateContent()}
                ></div>
            </Wrapper>
        </PostContentContainer>
    );
};

export default PostContent;
